export default {
	"transportOrderInfoOfTransportPlan": {
		"changeTime": "time modification"
	},
	"transportPlan": {
		"askCompleteTime": "required completion time"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/transportPlan/transportPlan.js